// Mémoire durable de l'espace adhérent : localStorage + IndexedDB + stockage persistant.
// iOS/Safari peut purger localStorage ; IndexedDB + navigator.storage.persist() résistent mieux.
const KEY = 'raav_espace_token';
const DB_NAME = 'raav_espace';
const STORE = 'kv';

const idb = () => new Promise((resolve, reject) => {
  const req = indexedDB.open(DB_NAME, 1);
  req.onupgradeneeded = () => req.result.createObjectStore(STORE);
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

const idbSet = async (val) => {
  const db = await idb();
  await new Promise((res, rej) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).put(val, KEY);
    tx.oncomplete = res; tx.onerror = () => rej(tx.error);
  });
  db.close();
};

const idbGet = async () => {
  const db = await idb();
  const val = await new Promise((res, rej) => {
    const req = db.transaction(STORE, 'readonly').objectStore(STORE).get(KEY);
    req.onsuccess = () => res(req.result || null);
    req.onerror = () => rej(req.error);
  });
  db.close();
  return val;
};

const idbDel = async () => {
  const db = await idb();
  await new Promise((res, rej) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).delete(KEY);
    tx.oncomplete = res; tx.onerror = () => rej(tx.error);
  });
  db.close();
};

export const sauverEspaceToken = async (token) => {
  try { localStorage.setItem(KEY, token); } catch { /* ignore */ }
  try { await idbSet(token); } catch { /* ignore */ }
  try { if (navigator.storage?.persist) await navigator.storage.persist(); } catch { /* ignore */ }
};

export const lireEspaceToken = async () => {
  try {
    const ls = localStorage.getItem(KEY);
    if (ls) return ls;
  } catch { /* ignore */ }
  try {
    const v = await idbGet();
    if (v) { try { localStorage.setItem(KEY, v); } catch { /* ignore */ } }
    return v;
  } catch { return null; }
};

export const oublierEspaceToken = async () => {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
  try { await idbDel(); } catch { /* ignore */ }
};

// Iter 655 (Kamel) — pré-charge les photos (notes, lieux de rendez-vous) dans le cache du Service Worker
// dès qu'on est en ligne, pour qu'elles s'affichent pendant le voyage même sans réseau.
export const precacherPhotos = async (urls) => {
  if (!('caches' in window) || !navigator.onLine) return;
  const uniques = [...new Set((urls || []).filter(u => typeof u === 'string' && /\/api\/(public\/docs|excursions\/photo)\//.test(u)))];
  if (!uniques.length) return;
  try {
    const c = await caches.open('raav-photos-v1');
    for (const u of uniques) {
      if (!(await c.match(u))) {
        try { const r = await fetch(u); if (r.ok) await c.put(u, r); } catch { /* réseau */ }
      }
    }
  } catch { /* quota / navigateur sans Cache API */ }
};
